export const WIDE_LEFT_PANEL_WIDTH = 400;
